
export const countriesArr = [
    {
        index: 0,
        title: "Беларусь",
        value: "BLR",
    },
    {
        index: 1,
        title: "Россия",
        value: "Russia",
    },
    {
        index: 2,
        title: "Китай",
        value: "China",
    },
];

export const subscribersArr = [
    {
        index: 0,
        title: "До 1000",
        value: "1000",
    },
    {
        index: 1,
        title: "5 000 - 10 000",
        value: "5000/10000",
    },
    {
        index: 2,
        title: "10 000 - 20 000",
        value: "10000/20000",
    },
    {
        index: 3,
        title: "20 000 - 50 000",
        value: "20000/50000",
    },
    {
        index: 4,
        title: "50 000 - 100 000",
        value: "50000/100000",
    },
    {
        index: 5,
        title: "от 100 000",
        value: "100000",
    },
];